<div class="blank-screen"></div>

<style>
    .blank-screen {
        width: 400px;
        height: 400px;
        background-color: white;
        margin: 0 auto; /* Centraliza horizontalmente */
        display: flex;
        justify-content: center; /* Centraliza horizontalmente */
        align-items: center; /* Centraliza verticalmente */
    }
</style>
